import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { isEmpty } from 'lodash';
import { Api } from '@/core/api';
import { useCurrentUser } from '@/core/hooks/useCurrentUser';
import { SeverityItem } from '@/server/services/GoogleBigQuery/BigQueryIncidentsClient.types';

export const QUERY_KEY_SEVERITY_LEVELS = 'severity-levels';

const buildSeverityNameByIdMap = (data: SeverityItem[] = []) => {
  const map = new Map<SeverityItem['SeverityID'], SeverityItem['SeverityName']>();
  data.forEach((level) => map.set(level.SeverityID, level.SeverityName));
  return map;
};

export const useSeverityLevelsData = () => {
  const { orgId } = useCurrentUser();

  const { data, ...query } = useQuery({
    queryKey: [QUERY_KEY_SEVERITY_LEVELS, orgId],
    queryFn: () => Api.mapEvents.getSeverityLevels({ orgId }),
    placeholderData: [],
    staleTime: Infinity,
  });

  const [severityNameById, setSeverityNameById] = useState(buildSeverityNameByIdMap(data));

  useEffect(() => {
    if (data && !isEmpty(data) && !severityNameById.size) {
      setSeverityNameById(buildSeverityNameByIdMap(data));
    }
  }, [data, severityNameById]);

  return {
    data,
    severityLevelsData: data || [],
    severityNameById,
    ...query,
  };
};
